import { Stack, styled } from '@mui/material'
import { ReactComponent as Bg } from './assets/bg.svg'
import VolumeBg from './assets/total-volume-bg.svg'
import TasksBg from './assets/rectangle.png'
import { Flex, FlexBetween, isDark } from 'styles'

export const PageWrap = styled('div')`
  width: 1200px;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
    padding: 0 20px;
  }
`

export const Title = styled('div')`
  display: inline-block;
  font-size: 96px;
  line-height: 102px;
  font-weight: 900;
  position: relative;
  color: ${(props) =>
    isDark(props) ? 'rgba(160, 238, 9, 1)' : 'rgba(98, 184, 13, 1)'};
  ${(props) => props.theme.breakpoints.down('md')} {
    font-size: 28px;
  }
`
export const TitleIconWrap = styled('div')`
  position: absolute;
  bottom: -14px;
  right: -150px;
  .star {
    position: absolute;
    top: -20px;
    right: 88px;
    path {
      fill: ${(props) =>
        isDark(props) ? 'rgba(250, 255, 12, 1)' : 'rgba(238, 149, 0, 1)'};
    }
  }
  .wrap {
    path {
      stroke: ${(props) =>
        isDark(props) ? 'rgba(250, 255, 12, 1)' : 'rgba(238, 149, 0, 1)'};
    }
  }
`
export const AdvantageWrap = styled(Flex)`
  flex-wrap: wrap;
  gap: 24px;
  justify-content: space-between;
  margin-top: 54px;
`
export const AdvantageItem = styled('div')`
  width: 588px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 12px;
  background: ${(props) =>
    isDark(props) ? 'rgba(255, 255, 255, 0.08)' : 'rgba(193, 193, 193, 0.08)'};
  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
  }
`
export const AdvantageItemTitle = styled('div')`
  font-size: 20px;
  line-height: 26px;
  font-weight: 600;
  text-transform: capitalize;
  color: ${(props) =>
    isDark(props) ? 'rgba(242, 242, 242, 1)' : 'rgba(51, 55, 67, 1)'};
`
export const AdvantageItemContent = styled(FlexBetween)`
  margin-top: 16px;
  align-items: start;
  gap: 130px;
  ${(props) => props.theme.breakpoints.down('md')} {
    gap: 16px;
  }
`
export const AdvantageItemContentText = styled('div')`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) =>
    isDark(props) ? 'rgba(189, 189, 189, 1)' : 'rgba(51, 55, 67, 1)'};
  flex: 1;
`
export const DataDashboardWrap = styled('div')`
  margin-top: 64px;
`
export const DataDashboardTitle = styled('div')`
  font-size: 32px;
  line-height: 32px;
  font-weight: 500;
  color: ${(props) =>
    isDark(props) ? 'rgba(255, 255, 255, 1)' : 'rgba(51, 55, 67, 1)'};
`
export const DataDashboardContent = styled(FlexBetween)`
  margin: 40px 0 120px;
  gap: 24px;
  flex-wrap: wrap;
`
export const DataItem = styled('div')`
  background: ${(props) =>
    isDark(props) ? 'rgba(255, 255, 255, 0.08)' : 'rgba(124, 124, 124, 0.08)'};
  padding: 20px;
  border-radius: 12px;
  width: 384px;
  ${(props) => props.theme.breakpoints.down('md')} {
    width: 100%;
  }
`
export const DataItemTitle = styled('div')`
  text-transform: uppercase;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) =>
    isDark(props) ? 'rgba(189, 189, 189, 1)' : 'rgba(90, 102, 137, 1)'};
`
export const DataItemValue = styled('div')`
  font-size: 28px;
  line-height: 28px;
  font-weight: 500;
  margin-top: 16px;
  color: ${(props) =>
    isDark(props) ? 'rgba(255, 255, 255, 1)' : 'rgba(7, 7, 7, 1)'};
`
export const DataItemTag = styled('div')`
  margin-top: 8px;
  height: 24px;
  line-height: 24px;
  padding: 0 8px;
  color: ${(props) =>
    isDark(props) ? 'rgba(20, 21, 26, 1)' : 'rgba(255, 255, 255, 1)'};
  display: inline-block;
  border-radius: 12px;
  background: ${(props) =>
    isDark(props) ? 'rgba(160, 238, 9, 1)' : 'rgba(98, 184, 13, 1)'};
  font-size: 14px;
  font-weight: 500;
`
export const BgBox = styled(Bg)`
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: none;
  z-index: 1;
  ellipse {
    fill: ${(props) =>
      isDark(props) ? 'rgba(130, 192, 11, 1)' : props.theme.color.primary20};
  }
`
export const TotalVolume = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 528px;
  height: 190px;
  padding: 32px 0 32px 48px;
  background: url(${VolumeBg});
  span {
    font-size: 24px;
    line-height: 30px;
    color: rgba(217, 255, 142, 1);
  }

  .value {
    b {
      font-size: 60px;
      line-height: 72px;

      &.locked {
        filter: blur(5px);
      }
    }
    i {
      font-size: 32px;
      font-style: normal;
      margin-left: 10px;
    }
  }
  .tips {
    display: flex;
    align-items: center;
    gap: 4px;
    color: rgba(148, 153, 155, 1);
    font-size: 16px;

    a {
      color: rgba(200, 244, 29, 1);
      text-decoration: underline;
    }
  }
`

export const TasksWrap = styled(Stack)`
  width: 1200px;
  height: 426px;
  background: url(${TasksBg}) 0 0 no-repeat;
  background-size: contain;
  margin-top: 70px;

  .head {
    font-size: 30px;
    line-height: 38px;
    font-weight: 900;
    text-align: center;
    color: rgba(217, 255, 142, 1);
  }
`
export const TasksList = styled(Stack)`
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 48px;
    height: 134px;
    border-bottom: 1px dotted rgba(217, 255, 142, 0.26);

    &:last-child {
      border: none;
    }
  }

  .title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 900;
    color: rgba(255, 255, 255, 1);
  }

  .coming {
    font-size: 24px;
    line-height: 32px;
    font-weight: 400;
    color: #94999b;
  }
  .total {
    //styleName: Display xs/Regular;
    font-size: 24px;
    font-weight: 400;
    line-height: 32px;
    color: rgba(149, 164, 173, 1);

    b {
      //styleName: Display sm/Black;
      font-size: 30px;
      font-weight: 900;
      line-height: 38px;
      color: rgba(255, 255, 255, 1);
      padding-left: 10px;

      &.locked {
        filter: blur(4px);
      }
    }
  }
`
